module.exports = `${require.publicPath}202.90747449.png`;